import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import MarketingProfileReadiness from './marketing-profile-readiness';
import BeddingConfig from './bedding-config';
import DestinationsSold from './destinations-sold';
import MarketServed from './marketServed';
import InterconnectingRooms from './interconnecting-rooms';
import CompanyTypes from './companyTypes';
import MarketSegments from './market-segments';
import Passengers from './passengers';
import RoomCount from './room-count';
import RoomSize from './room-size';
import TaxId from './tax-id';
import TourDuration from './tour-duration';
import SupplierLeftBarMembership from './memberships';
import R, { merge, prop, propOr } from 'ramda';

class ProfileLeftBarContainer extends Component {
  render() {
    const { profileToShow, routeName, isEditable, isSingleLocSupplier, companyProfileReducer } = this.props;

    const roomIsEditable = isEditable && (routeName !== 'profile' || routeName === 'profile' && isSingleLocSupplier) && profileToShow.productType === 'accommodation';
    const showInterConnectingRooms = (routeName === 'product' && (profileToShow.interconnectingRooms || roomIsEditable));
    const showTourDuration = (profileToShow.productType === 'nonAccommodation' && routeName === 'product');
    const showBeddingConfig = (routeName === 'product' && (Boolean(R.pathOr(0, ['bedsAndSofas', 'rooms', 'length'], profileToShow)) || roomIsEditable));
    const showDestinationsSold = profileToShow.type === 'Contractor';
    const showMarketServed = profileToShow.type === 'Contractor';
    const showTaxId = (isEditable && profileToShow.type === 'Contractor');
    const showCompanyTypes = profileToShow.type === 'Contractor' || profileToShow.type === 'Supplier';
    const showMarketSegments = routeName !== 'product';
    const showMarketingProfileReadiness = isEditable;
    const showPassengers = routeName === 'product' && profileToShow.productType === 'nonAccommodation';
    const showRoomSize = (routeName === 'product' && (profileToShow.roomSizeInfo.value && profileToShow.roomSizeInfo.unit || roomIsEditable));
    const showLocationRoomCount = ((routeName === 'location' || routeName === 'profile' && isSingleLocSupplier) && Boolean(profileToShow.roomCount || roomIsEditable));
    const showProductRoomCount = Boolean(routeName === 'product' && (profileToShow.roomSizeInfo.value && profileToShow.roomCountInfo.unit || roomIsEditable));
    const roomCountProps = {
      roomIsEditable,
      showLocationRoomCount,
      showProductRoomCount,
    };

    const isEditableProps = {
      roomIsEditable,
    };

    return (
        <div>
          {!isEditable &&
            <SupplierLeftBarMembership
              profileToShow={routeName === 'profile' ? profileToShow : merge(profileToShow, {
                companyBadges: propOr([], 'companyBadges', companyProfileReducer[prop(0, Object.keys(companyProfileReducer))]),
              })}
              routeName={routeName}
              isEditable={isEditable}
              isSingleLocSupplier={isSingleLocSupplier}
            />}
          {showMarketingProfileReadiness ? <MarketingProfileReadiness /> : undefined}
          {showRoomSize ? <RoomSize {...isEditableProps} {...this.props} /> : undefined}
          {showInterConnectingRooms ? <InterconnectingRooms {...isEditableProps} {...this.props} /> : undefined}
          {showBeddingConfig ? <BeddingConfig {...this.props} /> : undefined}
          {showTourDuration ? <TourDuration {...this.props} /> : undefined}
          {showPassengers ? <Passengers {...this.props} /> : undefined}
          {showCompanyTypes ? <CompanyTypes {...this.props} />: undefined}
          {showMarketSegments ? <MarketSegments {...this.props} /> : undefined}
          {showDestinationsSold && <DestinationsSold {...this.props} />}
          {showMarketServed && <MarketServed {...this.props} />}
          {showTaxId ? <TaxId {...this.props} /> : undefined}
          {showLocationRoomCount || showProductRoomCount ? <RoomCount {...roomCountProps} {...this.props} /> : undefined }
        </div>
    );
  }
}

ProfileLeftBarContainer.propTypes = {
  profileToShow: PropTypes.object,
  routeName: PropTypes.string,
  isEditable: PropTypes.bool,
  isSingleLocSupplier: PropTypes.bool,
  companyProfileReducer: PropTypes.object,
};

const mapStateToProps = ({ companyProfile }) => ({
  companyProfileReducer: companyProfile.toJS(),
});

export default connect(mapStateToProps)(ProfileLeftBarContainer);



// WEBPACK FOOTER //
// ./src/app/components/profile/profile-left-bar/profile-left-bar-container.jsx